import React from "react";
import { useTranslation } from "react-i18next";

export default function DemoDataNotice({ textKey = "common.demoDataNotice.illustrativeFigure" }) {
  const { t } = useTranslation();
  return (
    <div style={{ fontSize: "0.75rem", color: "#8B96A8", fontStyle: "italic", marginTop: "2px" }}>
      ({t(textKey)})
    </div>
  );
}
